import React, { FC, memo } from 'react';

import { LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import PolicyDescription from '../../../Common/PolicyDescription';
import PolicySelect from '../../../Common/PolicySelect';
import { Policy, SecuredFile } from '@/types/types';
import { getPolicyAggregate, PolicyAggregate } from '../../../utils';
import styles from './SetPolicyComponent.module.scss';

interface SetPolicyProps {
    file: SecuredFile;
    hasPolicies: boolean;
    selectedPolicy: Policy;
    changePolicy: (policyId: string) => Promise<void> | void;
}

const nameSpace = 'filesTable.modals.settings.policy';

const SetPolicyComponent: FC<SetPolicyProps> = ({
    file,
    hasPolicies,
    selectedPolicy,
    changePolicy,
}) => {
    const { t } = useTranslation();
    const policyAggregate: PolicyAggregate = selectedPolicy ? getPolicyAggregate(selectedPolicy) : {};
    const isLocked = !!file?.policy_set_by_rule;

    return (
        <div className={styles['set-policy-container']}>
            {(selectedPolicy && hasPolicies) && file && (
                <PolicySelect
                    className={styles['policy-select']}
                    selectedPolicyId={selectedPolicy.id}
                    onChange={changePolicy}
                    disabled={isLocked}
                />
            )}
            <div className={styles['description-wrapper']}>
                {selectedPolicy && hasPolicies
                && <PolicyDescription policyAggregate={policyAggregate} />}
            </div>
            {isLocked && (
                <div className={styles['locked-policy-banner']}>
                    <span>{t(`${nameSpace}.lockedByRule`)}</span>
                </div>
            )}
            <hr className={styles['locked-divider']} />
        </div>
    );
};

export default memo(SetPolicyComponent);
